import * as i0 from "@angular/core";
import * as i1 from "../modal-base/components/modal-base.component";
import * as i2 from "../modal-base/components/simple-modal-header.component";
function PreviewImageModalComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-simple-modal-header", 5);
    i0.ɵɵlistener("closeModalHandler", function PreviewImageModalComponent_Conditional_1_Template_ycn_simple_modal_header_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("header", "Preview");
} }
export class PreviewImageModalComponent {
    constructor() {
        this.showDecorations = true;
        this.previewImageUrl = '';
        this.modalOpen = false;
    }
    openModal(previewImageUrl) {
        this.previewImageUrl = previewImageUrl;
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
    }
}
PreviewImageModalComponent.ɵfac = function PreviewImageModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PreviewImageModalComponent)(); };
PreviewImageModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PreviewImageModalComponent, selectors: [["ycn-preview-image-modal"]], inputs: { showDecorations: "showDecorations" }, standalone: false, decls: 6, vars: 6, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "header"], [1, "modal-body"], [1, "preview-wrap"], [1, "preview-image", 3, "src"], [3, "closeModalHandler", "header"]], template: function PreviewImageModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function PreviewImageModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵtemplate(1, PreviewImageModalComponent_Conditional_1_Template, 1, 1, "ycn-simple-modal-header", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div");
        i0.ɵɵelement(5, "img", 4);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-no-border")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showDecorations ? 1 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("preview-section", ctx.showDecorations);
        i0.ɵɵadvance();
        i0.ɵɵproperty("src", ctx.previewImageUrl, i0.ɵɵsanitizeUrl);
    } }, dependencies: [i1.ModalBaseComponent, i2.SimpleModalHeaderComponent], encapsulation: 2 });
